var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.attachmentList.length > 0
    ? _c(
        "ul",
        { staticClass: "attachment-list" },
        _vm._l(_vm.attachmentList, function (att, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("md-icon", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.fileType === "document" ? "picture_as_pdf" : "image"
                    ) +
                    "\n        "
                ),
              ]),
              _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                _vm._v("\n            " + _vm._s(att.file.name) + "\n        "),
              ]),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }